<template>
    <section id="before-archive">
        <b-modal 
            @hide="onHide" 
            id="before-archive-modal" 
            ref="beforeArchive" 
            hide-header 
            hide-footer>
                <div class="before-archive mx-auto d-flex align-items-center justify-content-center flex-column">
                    <div style="width: 325px" class="mx-auto">
                        <div class="text-center">
                            <BeforeArchiveIcon/>
                        </div>
                        
                        <Button 
                            @click.native="go_back()"
                            type="primary"
                            class="w-100 mt-3">
                                Go Back
                        </Button>
                    </div>
                </div>
        </b-modal>
    </section>
</template>

<script>
import { BeforeArchiveIcon } from '../components/Icons'
import Button from '../components/Theme/Button'
export default {
name: 'BeforeArchive',
components: {
    Button,
    BeforeArchiveIcon
},
methods: {
    onHide: function(evt) {
        this.$bvModal.hide('before-archive-modal')
    },
    go_back: function() {
        this.$bvModal.hide('before-archive-modal')
    }
}
}
</script>

<style lang="scss" scoped>

div.before-archive {
    width: 450px;
    height: 313px;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 5px;


        button {
            padding-top: 12px;
            padding-bottom: 12px;
        }

}
</style>